import { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ActionLogItem, ApplicationState } from '@mews-commander/types';
import { UnicodeEntity } from '@mews/enums';
import { Typography, Stack, Container, getToken } from '@optimus-web/core';
import { LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { getProfile } from '@mews-commander/legacy-entities/src/ducks';
import { ActionLogData } from '../data';
import ActionLogItemLink from './ActionLogItemLink';
import ActionLogItemText from './ActionLogItemText';
import { ProfileAvatar } from './ProfileAvatar';

interface ActionLogItemRowProps {
    actionLogItem: ActionLogItem;
    actionLogData: ActionLogData;
}

export const ActionLogItemRow: FC<ActionLogItemRowProps> = ({ actionLogItem, actionLogData }) => {
    const profile = useSelector((state: ApplicationState) => getProfile(state, { id: actionLogItem.profileId }));

    return (
        <ActionLogItemRowWrapper>
            <Container padding={['300', '200']}>
                <Stack distribution="space-between" itemAlignment="center" fill>
                    <Stack itemAlignment="center" spacing="100">
                        <ProfileAvatar profileId={actionLogItem.profileId} actionLogData={actionLogData} />
                        <Stack vertical>
                            <Stack spacing="50">
                                <strong>{actionLogItem.creatorNameOverride ?? profile?.name}</strong>
                                <span>{UnicodeEntity.GreaterThanSign}</span>
                                <ActionLogItemLink
                                    entityType={actionLogItem.entityType}
                                    entityId={actionLogItem.entityId}
                                />
                            </Stack>
                            <ActionLogItemText
                                // @ts-expect-error old/generated type mismatch
                                actionLogItem={actionLogItem}
                            />
                        </Stack>
                    </Stack>
                    <Typography textStyle="bodySmall" as="div">
                        <LocalizedDateTimeFromUtc utcString={actionLogItem.createdUtc} />
                    </Typography>
                </Stack>
            </Container>
        </ActionLogItemRowWrapper>
    );
};

const ActionLogItemRowWrapper = styled.div`
    background-color: ${getToken('paletteBasicsWhite')};

    &:not(:last-child) {
        border-bottom: 1px solid ${getToken('borderDisabled')};
    }
`;
